import { createFileRoute, useParams, useSearch } from '@tanstack/react-router';
import { z } from 'zod';

import { WorkspaceAssessmentDetailScreen } from '@/features/assessments/components/workspace/AssessmentDetailScreen';

const searchSchema = z.object({
  tab: z.enum(['overview', 'questions', 'scoring']).catch('overview').optional(),
});

export const Route = createFileRoute('/_staff/admin/workspace/assessments/$templateId/')({
  validateSearch: searchSchema,
  component: Wrap,
});

function Wrap() {
  const { templateId } = useParams({
    from: '/_staff/admin/workspace/assessments/$templateId/',
  });
  const { tab } = useSearch({ from: '/_staff/admin/workspace/assessments/$templateId/' });
  return <WorkspaceAssessmentDetailScreen templateId={templateId} initialTab={tab ?? 'overview'} />;
}
